import { render } from "./LeadStatusAndRating.vue?vue&type=template&id=79d20b72"
import script from "./LeadStatusAndRating.vue?vue&type=script&lang=js"
export * from "./LeadStatusAndRating.vue?vue&type=script&lang=js"
script.render = render

export default script